module.exports = __webpack_public_path__ + "media/icon/favicon-32x32-6cd84f47.png";